import './text.scss';

class Text {
    constructor(element) {
        this.$root = element;
        this.$readMoreToggle = this.$root.querySelector('[data-readmore="toggle"]');

        this.init();
    }

    init () {
        this.$readMoreToggle.onclick = () => {
            this.$readMoreToggle.setAttribute('aria-expanded', 'true');

            this.$root.setAttribute('tabindex', '0');

            setTimeout(() => {
                this.$root.removeAttribute('tabindex');
            }, 500);
        };
    }
}

export { Text };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$text = $context.querySelectorAll('[data-readmore="root"]');

        if ($$text.length > 0) {
            $$text.forEach($text => {
                new Text($text);
            });
        }
    }
});
